import React, { useState } from "react";
import { createStyles, Text, Popover, Group, Button, TextInput, ScrollArea, ActionIcon } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import tinycolor from "tinycolor2";

import isDark from "../../../utils/IsDarkColor";
import isSpaceThemed from "../../../utils/IsSpaceThemed";

const useStyles = createStyles((theme, { colors }) => ({
  container: {
    backgroundColor: "transparent",
    border: isSpaceThemed(colors)
      ? `1px solid ${
          isDark(colors.background_color)
            ? tinycolor(colors.background_color).lighten(20).toString()
            : tinycolor(colors.background_color).darken(20).toString()
        } !important`
      : `1px solid #e9ecef !important`,
    "&:hover": {
      backgroundColor: isSpaceThemed(colors)
        ? isDark(colors.background_color)
            ? tinycolor(colors.background_color).lighten(20).toString()
            : tinycolor(colors.background_color).darken(20).toString()
      : "#e9ecef"
    }
  },
}));

export default function FilterDropdown({
  label,
  colors,
  dropdownData,
  onSearch
}) {
  const { classes } = useStyles({ colors });

  const [opened, setOpened] = useState(false);
  const [search, setSearch] = useState("");

  const filteredData = Array.isArray(dropdownData) ? dropdownData.filter((item) => {
    return String(item.name).toLowerCase().includes(search.toLowerCase());
  }) : [];

  const textColor = isSpaceThemed(colors) ? colors.default_text_color : "grey";

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      spacing={5}
      width={250}
      position="bottom"
      placement="start"
      target={
        <Button
          variant="default"
          size="xs"
          radius="md"
          className={classes.container}
          leftIcon={<FontAwesomeIcon icon={solid("tag")} color={textColor} size="sm" />}
          rightIcon={<FontAwesomeIcon icon={solid("chevron-down")} color={textColor} size="sm" />}
          onClick={() => setOpened(!opened)}
        >
          <Text size="xs" color={textColor} style={{ textTransform: "capitalize" }}>
            {label}: {search.trim().length ? search : "All"}
          </Text>
        </Button>
      }
    >
      <Group spacing={0}>
        <TextInput
          placeholder={"Search..."}
          value={search}
          size="xs"
          onChange={(e) => {
            setSearch(e.currentTarget.value);
            if (typeof onSearch === "function" && (filteredData.length === 0 || e.currentTarget.value.trim().length === 0)) {
              onSearch(e.currentTarget.value);
            }
          }}
          m={5}
          sx={{ flex: 1 }}
        />
        {filteredData.length > 0 && search.length > 0 && (
          <ActionIcon
            onClick={() => {
              setSearch("");
              if (typeof onSearch === "function") {
                onSearch("");
              }
            }}
          >
            <FontAwesomeIcon icon={solid("xmark")} color="grey" size="sm" />
          </ActionIcon>
        )}
      </Group>
      <ScrollArea style={{ height: filteredData.length > 5 ? 200 : null }} type="scroll" offsetScrollbars>
        {filteredData.map((tag, key) => (
          <Group
            key={key}
            spacing={0}
            p={5}
            my={5}
            onClick={() => {
              setOpened(false);
              setSearch(tag.name);
              if (typeof onSearch === "function") {
                onSearch(tag.name);
              }
            }}
            sx={{
              flex: 1,
              cursor: "pointer",
              borderRadius: 4,
              '&:hover': { backgroundColor: '#f5f5f5' }
            }}
          >
            <Text color="grey" size="xs" pl={10} lineClamp={1} sx={{ flex: 1 }}>
              {tag.name}
            </Text>
          </Group>
        ))}
      </ScrollArea>
    </Popover>
  );
};